import React from "react";
import "./AngelsPage.css";
import ThreeAngelsmp4 from "../assets/ThreeAngels.mp4";

export default function ThreeAngels() {
  return (
    <main className="threeangels">
      <header className="ta-hero">
        <h1 className="ta-title">رسالة الملائكة الثلاث</h1>

       
        <video
          className="ta-gif"
          src={ThreeAngelsmp4}
          autoPlay
          loop
          muted
          playsInline
        />

        <p className="ta-subtitle">من سفر رؤيا الاصحاح 14، الايات 12-6.</p>
      </header>

      <section className="ta-section">
        <p className="ta-paragraph">
          ثُمَّ رَأَيْتُ مَلاَكًا آخَرَ طَائِرًا فِي وَسَطِ السَّمَاءِ مَعَهُ
          <strong> بَشَارَةٌ أَبَدِيَّةٌ </strong>
          ، لِيُبَشِّرَ السَّاكِنِينَ عَلَى الأَرْضِ وَكُلَّ أُمَّةٍ وَقَبِيلَةٍ
          وَلِسَانٍ وَشَعْبٍ، قَائِلًا بِصَوْتٍ عَظِيمٍ:
          <strong>
            «خَافُوا اللهَ وَأَعْطُوهُ مَجْدًا، لأَنَّهُ قَدْ جَاءَتْ سَاعَةُ
            دَيْنُونَتِهِ، وَاسْجُدُوا لِصَانِعِ السَّمَاءِ وَالأَرْضِ
            وَالْبَحْرِ وَيَنَابِيعِ الْمِيَاهِ».
          </strong>
        </p>

        <p className="ta-paragraph">
          ثُمَّ تَبِعَهُ مَلاَكٌ آخَرُ قَائِلًا:
          <strong>
            «سَقَطَتْ! سَقَطَتْ بَابِلُ الْمَدِينَةُ الْعَظِيمَةُ، لأَنَّهَا سَقَتْ
            جَمِيعَ الأُمَمِ مِنْ خَمْرِ غَضَبِ زِنَاهَا!»
          </strong>
        </p>

        <p className="ta-paragraph">
          ثُمَّ تَبِعَهُمَا مَلاَكٌ ثَالِثٌ قَائِلًا بِصَوْتٍ عَظِيمٍ:
          <strong>
            «إِنْ كَانَ أَحَدٌ يَسْجُدُ لِلْوَحْشِ وَلِصُورَتِهِ، وَيَقْبَلُ
            سِمَتَهُ عَلَى جَبْهَتِهِ أَوْ عَلَى يَدِهِ، فَهُوَ أَيْضًا سَيَشْرَبُ
            مِنْ خَمْرِ غَضَبِ اللهِ، الْمَصْبُوبِ صِرْفًا فِي كَأْسِ غَضَبِهِ،
            وَيُعَذَّبُ بِنَارٍ وَكِبْرِيتٍ أَمَامَ الْمَلاَئِكَةِ الْقِدِّيسِينَ
            وَأَمَامَ الْخَرُوفِ. وَيَصْعَدُ دُخَانُ عَذَابِهِمْ إِلَى أَبَدِ
            الآبِدِينَ. وَلاَ تَكُونُ رَاحَةٌ نَهَارًا وَلَيْلًا لِلَّذِينَ
            يَسْجُدُونَ لِلْوَحْشِ وَلِصُورَتِهِ وَلِكُلِّ مَنْ يَقْبَلُ سِمَةَ
            اسْمِهِ».
          </strong>
        </p>

        <p className="ta-paragraph ta-emph">
          هُنَا صَبْرُ الْقِدِّيسِينَ. هُنَا الَّذِينَ يَحْفَظُونَ وَصَايَا اللهِ
          وَإِيمَانَ يَسُوعَ.
        </p>

        <p className="ta-paragraph">
          رسائل الملائكة الثلاثة هي تفسير للرسائل التي أعلنتها ثلاثة ملائكة في سفر
          الرؤيا 14: 6-12 في الكتاب المقدس. وتُعتبر هذه الرسائل تحذيرات للعالم بأسره
          قبل المجيء الثاني ليسوع المسيح، وهي جزء أساسي من إيمان كنيسة السبتيين
          الأدفنتست ورسالتها.
        </p>

        <h3 className="ta-h3">رسالة الملاك الأول (رؤيا 14: 6-7)</h3>
        <p className="ta-paragraph">
          تُعلن رسالة الملاك الأول "الإنجيل الأبدي" وتدعو إلى العودة إلى الله...
        </p>

        <h3 className="ta-h3">رسالة الملاك الثاني (رؤيا 14: 8)</h3>
        <p className="ta-paragraph">
          يُعلن الملاك الثاني "سَقَطَتْ، سَقَطَتْ بَابِلُ الْعَظِيمَةُ"...
        </p>

        <h3 className="ta-h3">رسالة الملاك الثالث (رؤيا 14: 9-11)</h3>
        <p className="ta-paragraph">
          يُطلق الملاك الثالث تحذيرًا صارمًا ضد عبادة "الوحش وصورته"...
        </p>

        <h3 className="ta-h3">أهميتها للسبتيين</h3>
        <p className="ta-paragraph">
          تعتبر رسائل الملائكة الثلاثة ذات أهمية قصوى للأدفنتست السبتيين...
        </p>
      </section>
    </main>
  );
}
